import { Device } from 'entities/Device';
import { Installation } from 'entities/Installation';
import { Language } from 'entities/Language';

import en_mac_app_1 from 'shared/assets/images/guides/en/mac/app/1.png';
import en_mac_app_2 from 'shared/assets/images/guides/en/mac/app/2.png';
import en_mac_app_3 from 'shared/assets/images/guides/en/mac/app/3.png';
import en_mac_app_4 from 'shared/assets/images/guides/en/mac/app/4.png';
import en_mac_app_5 from 'shared/assets/images/guides/en/mac/app/5.png';

import ru_mac_app_1 from 'shared/assets/images/guides/ru/mac/app/1.png';
import ru_mac_app_2 from 'shared/assets/images/guides/ru/mac/app/2.png';
import ru_mac_app_3 from 'shared/assets/images/guides/ru/mac/app/3.png';
import ru_mac_app_4 from 'shared/assets/images/guides/ru/mac/app/4.png';
import ru_mac_app_5 from 'shared/assets/images/guides/ru/mac/app/5.png';

import ru_windows_app_1 from 'shared/assets/images/guides/ru/windows/app/1.png';
import ru_windows_app_2 from 'shared/assets/images/guides/ru/windows/app/2.png';
import ru_windows_app_3 from 'shared/assets/images/guides/ru/windows/app/3.png';
import ru_windows_app_4 from 'shared/assets/images/guides/ru/windows/app/4.png';
import ru_windows_app_5 from 'shared/assets/images/guides/ru/windows/app/5.png';

import en_windows_app_1 from 'shared/assets/images/guides/en/windows/app/1.png';
import en_windows_app_2 from 'shared/assets/images/guides/en/windows/app/2.png';
import en_windows_app_3 from 'shared/assets/images/guides/en/windows/app/3.png';
import en_windows_app_4 from 'shared/assets/images/guides/en/windows/app/4.png';
import en_windows_app_5 from 'shared/assets/images/guides/en/windows/app/5.png';

import en_linux_app_1 from 'shared/assets/images/guides/en/linux/app/1.png';
import linux_app_2 from 'shared/assets/images/guides/en/linux/app/2.png';
import linux_app_3 from 'shared/assets/images/guides/en/linux/app/3.png';
import linux_app_4 from 'shared/assets/images/guides/en/linux/app/4.png';

import ru_linux_app_1 from 'shared/assets/images/guides/ru/linux/app/1.png';

import en_iphone_app_1 from 'shared/assets/images/guides/en/iphone/app/1.png';
import en_iphone_app_2 from 'shared/assets/images/guides/en/iphone/app/2.png';
import en_iphone_app_3 from 'shared/assets/images/guides/en/iphone/app/3.png';
import en_iphone_app_4 from 'shared/assets/images/guides/en/iphone/app/4.png';
import en_iphone_app_5 from 'shared/assets/images/guides/en/iphone/app/5.png';

import ru_iphone_app_1 from 'shared/assets/images/guides/ru/iphone/app/1.png';
import ru_iphone_app_2 from 'shared/assets/images/guides/ru/iphone/app/2.png';
import ru_iphone_app_3 from 'shared/assets/images/guides/ru/iphone/app/3.png';
import ru_iphone_app_4 from 'shared/assets/images/guides/ru/iphone/app/4.png';
import ru_iphone_app_5 from 'shared/assets/images/guides/ru/iphone/app/5.png';

import en_android_app_1 from 'shared/assets/images/guides/en/android/app/1.png';
import en_android_app_2 from 'shared/assets/images/guides/en/android/app/2.png';
import en_android_app_3 from 'shared/assets/images/guides/en/android/app/3.png';
import en_android_app_4 from 'shared/assets/images/guides/en/android/app/4.png';
import en_android_app_5 from 'shared/assets/images/guides/en/android/app/5.png';
import en_android_app_6 from 'shared/assets/images/guides/en/android/app/6.png';

import ru_android_app_1 from 'shared/assets/images/guides/ru/android/app/1.png';
import ru_android_app_2 from 'shared/assets/images/guides/ru/android/app/2.png';
import ru_android_app_3 from 'shared/assets/images/guides/ru/android/app/3.png';
import ru_android_app_4 from 'shared/assets/images/guides/ru/android/app/4.png';
import ru_android_app_5 from 'shared/assets/images/guides/ru/android/app/5.png';
import ru_android_app_6 from 'shared/assets/images/guides/ru/android/app/6.png';

const images: Record<
  Language,
  Record<Device, Record<Installation, Record<number, string | string[]>>>
> = {
  ru: {
    mac: {
      app: {
        1: ru_mac_app_1,
        2: ru_mac_app_2,
        3: ru_mac_app_3,
        4: ru_mac_app_4,
        5: ru_mac_app_5,
      },
    },
    windows: {
      app: {
        1: ru_windows_app_1,
        2: ru_windows_app_2,
        3: ru_windows_app_3,
        4: ru_windows_app_4,
        5: ru_windows_app_5,
      },
    },
    linux: {
      app: {
        1: ru_linux_app_1,
        2: linux_app_2,
        3: linux_app_3,
        4: linux_app_4,
      },
    },
    iphone: {
      app: {
        1: ru_iphone_app_1,
        2: ru_iphone_app_2,
        3: ru_iphone_app_3,
        4: ru_iphone_app_4,
        5: ru_iphone_app_5,
      },
    },
    android: {
      app: {
        1: ru_android_app_1,
        2: ru_android_app_2,
        3: ru_android_app_3,
        4: ru_android_app_4,
        5: ru_android_app_5,
        6: ru_android_app_6,
      },
    },
  },
  en: {
    mac: {
      app: {
        1: en_mac_app_1,
        2: en_mac_app_2,
        3: en_mac_app_3,
        4: en_mac_app_4,
        5: en_mac_app_5,
      },
    },
    windows: {
      app: {
        1: en_windows_app_1,
        2: en_windows_app_2,
        3: en_windows_app_3,
        4: en_windows_app_4,
        5: en_windows_app_5,
      },
    },
    linux: {
      app: {
        1: en_linux_app_1,
        2: linux_app_2,
        3: linux_app_3,
        4: linux_app_4,
      },
    },
    iphone: {
      app: {
        1: en_iphone_app_1,
        2: en_iphone_app_2,
        3: en_iphone_app_3,
        4: en_iphone_app_4,
        5: en_iphone_app_5,
      },
    },
    android: {
      app: {
        1: en_android_app_1,
        2: en_android_app_2,
        3: en_android_app_3,
        4: en_android_app_4,
        5: en_android_app_5,
        6: en_android_app_6,
      },
    },
  },
};

export const getImageByParams = (
  device: Device,
  language: Language
) => {
  return (number: number) => {
    return images[language][device]["app"][number];
  };
};
